module.exports = __webpack_public_path__ + "static/media/loginPageImage.3b24ead0.svg";